import { z } from 'zod'
import { apiClient } from './client'
import type { AuthUser } from '../store/authStore'

export const loginSchema = z.object({
  email: z.string().email('Email inválido'),
  password: z.string().min(6, 'Mínimo 6 caracteres'),
  recordar: z.boolean().optional(),
})

export type LoginInput = z.infer<typeof loginSchema>

export interface LoginResponse {
  token: string
  refreshToken: string
  usuario: AuthUser
}

export const authApi = {
  login: (data: Omit<LoginInput, 'recordar'>) =>
    apiClient.post<LoginResponse>('/auth/login', data).then((r) => r.data),

  logout: () =>
    apiClient.post('/auth/logout').then((r) => r.data),

  refresh: (refreshToken: string) =>
    apiClient.post<{ token: string }>('/auth/refresh', { refreshToken }).then((r) => r.data),
}
